import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { categoriesApi } from '../services/api';
import Explorar from '../pages/Explorar';
import NegocioDetalhes from '../pages/NegocioDetalhes';

export default function CategoryOrBusinessRouter() {
  const { municipioSlug, categoriaSlug, secondSlug } = useParams();
  const [status, setStatus] = useState('loading'); // loading | subcategory | business | redirect
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function resolve() {
      try {
        const cats = await categoriesApi.list();
        const parent = cats.find(c => c.id === categoriaSlug || c.slug === categoriaSlug);
        if (!parent) {
          // Tentativa 2: URL antiga que caiu em slug renomeado — casa por slug_original_v1
          const legacy = cats.find(c => c.slug_original_v1 === categoriaSlug);
          if (legacy?.slug && legacy.slug !== categoriaSlug) {
            const tail = secondSlug ? `/${secondSlug}` : '';
            if (!cancelled) {
              setRedirectTo(`/${municipioSlug}/${legacy.slug}${tail}`);
              setStatus('redirect');
            }
            return;
          }
          if (!cancelled) setStatus('business');
          return;
        }
        // Categoria arquivada com sucessora v2 → redireciona pra ela
        if (parent.redirect_to_v2 && parent.redirect_to_v2 !== categoriaSlug) {
          const tail = secondSlug ? `/${secondSlug}` : '';
          if (!cancelled) {
            setRedirectTo(`/${municipioSlug}/${parent.redirect_to_v2}${tail}`);
            setStatus('redirect');
          }
          return;
        }
        const subs = parent.subcategorias || [];
        const norm = (s) => (s || '').toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase().replace(/[^\w\s-]/g, '')
          .replace(/[-\s]+/g, '-').replace(/^-+|-+$/g, '');
        const targetSlug = norm(secondSlug);
        const hit = subs.find(s => norm(s) === targetSlug);
        if (!cancelled) setStatus(hit ? 'subcategory' : 'business');
      } catch {
        if (!cancelled) setStatus('business');
      }
    }
    resolve();
    return () => { cancelled = true; };
  }, [municipioSlug, categoriaSlug, secondSlug]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="route-resolver-loading">
        <div className="w-8 h-8 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'redirect' && redirectTo) {
    return <Navigate to={redirectTo} replace data-testid="route-redirect-v1-to-v2" />;
  }

  return status === 'subcategory' ? <Explorar /> : <NegocioDetalhes />;
}
